/**
 * The form of an IBAN we store and compare: no separators, upper case. Keeps
 * the exact-match duplicate check working however the investor typed it.
 * Lossless, so an overlong entry reaches validation as it was typed.
 */
export const compactIBAN = (value?: string | null): string =>
  (value ?? "").replace(/[^a-z0-9]/gi, "").toUpperCase();

/**
 * Groups an IBAN the way a statement prints it, so a mis-keyed character is
 * easy to spot. For display in an input; submit `compactIBAN` instead.
 * Idempotent, so it can run on every keystroke.
 */
export const formatIBAN = (value?: string | null): string =>
  compactIBAN(value).replace(/.{4}(?=.)/g, "$& ");
